module.exports = __webpack_public_path__ + "img/graph.7d3b4bba.svg";